import { fetchGeoIpWithRedirect } from "@utils/fetch-geoip"
import { formatMarketo, submitMarketo } from "./marketo"
import { formatNorthstar, submitNorthstar } from "./northstar"
import { resetRecaptcha, verifyRecaptcha } from "./recaptcha"

export const submitForm = async (
  values,
  { shouldPostToNorthstar, shouldScheduleMeeting, shouldVerifyRecaptcha, recaptchaRef, rejectOnMarketoError } = {}
) => {
  const geoIp = await fetchGeoIpWithRedirect()
  resetRecaptcha(recaptchaRef)
  const recaptcha = await recaptchaRef.current.executeAsync()
  const northstarVals = shouldPostToNorthstar && formatNorthstar({ ...values, recaptcha })
  const marketoVals = formatMarketo({ ...values, recaptcha }, geoIp)

  return (
    shouldVerifyRecaptcha
      ? verifyRecaptcha(recaptcha).then((data) => {
          if (data.success !== true) {
            recaptchaRef.current.reset()
            return Promise.reject(new Error("Invalid recaptcha", { cause: { code: "InvalidRecaptcha" } }))
          }
          return true
        })
      : Promise.resolve(true)
  )
    .then(() => (shouldPostToNorthstar ? submitNorthstar(northstarVals) : Promise.resolve(true)))
    .then(() => submitMarketo(marketoVals, recaptcha, rejectOnMarketoError))
    .then(() => {
      // if scheduleMeeting option is set, allow users to schedule a meeting with drift
      shouldScheduleMeeting &&
        typeof window.drift === "function" &&
        window.drift("collectFormData", "#contact-form-container", {
          campaignId: 2252052,
          mapFields: true,
        })
      // Note: if the above fails, i.e. drift request blocked but the snippet is included, this throws?
      // I don't see any issues in Sentry, so it may be OK. Unlikely to only have Drift blocked

      return {}
    })
}
